// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#item-info-modal .modal-content{
    background: rgba(40, 40, 40, 0.6);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.7);
}

#item-info-modal .btn-close{
    color: white;
}

#item-info-modal .modal-header{
    border: 0;
}

#item-info-modal .modal-title{
    font-family: 'Milonga', serif;
}

#item-info-modal .rarity-name{
    font-family: 'Ubuntu Mono';
    font-size: 2em;
    background-image: radial-gradient(93% 87% at 87% 89%, rgba(0, 0, 0, 0.23) 0%, transparent 86.18%), radial-gradient(66% 87% at 26% 20%, rgba(255, 255, 255, 0.41) 0%, rgba(255, 255, 255, 0) 69.79%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 2px 19px 31px rgba(0, 0, 0, 0.2);
}

#item-info-modal .slot{
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
    border-radius: 0.2rem;
    font-family: 'Ubuntu Mono';
}

#item-info-modal .tag{
    width: 5rem;
}

#item-info-modal .item-links{
    font-size: 2.5em;
}

#item-info-modal .item-slot{
    font-size: 1.5em;
}

#item-info-modal .item-price{
    font-size: 1.5em;
}

#item-info-modal .hero-name{
    font-size: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ItemInfoModal.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,yCAAyC;IACzC,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,gOAAgO;IAChO,4CAA4C;AAChD;;AAEA;IACI,0GAA0G;IAC1G,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["#item-info-modal .modal-content{\n    background: rgba(40, 40, 40, 0.6);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.7);\n}\n\n#item-info-modal .btn-close{\n    color: white;\n}\n\n#item-info-modal .modal-header{\n    border: 0;\n}\n\n#item-info-modal .modal-title{\n    font-family: 'Milonga', serif;\n}\n\n#item-info-modal .rarity-name{\n    font-family: 'Ubuntu Mono';\n    font-size: 2em;\n    background-image: radial-gradient(93% 87% at 87% 89%, rgba(0, 0, 0, 0.23) 0%, transparent 86.18%), radial-gradient(66% 87% at 26% 20%, rgba(255, 255, 255, 0.41) 0%, rgba(255, 255, 255, 0) 69.79%, rgba(255, 255, 255, 0) 100%);\n    box-shadow: 2px 19px 31px rgba(0, 0, 0, 0.2);\n}\n\n#item-info-modal .slot{\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;\n    border-radius: 0.2rem;\n    font-family: 'Ubuntu Mono';\n}\n\n#item-info-modal .tag{\n    width: 5rem;\n}\n\n#item-info-modal .item-links{\n    font-size: 2.5em;\n}\n\n#item-info-modal .item-slot{\n    font-size: 1.5em;\n}\n\n#item-info-modal .item-price{\n    font-size: 1.5em;\n}\n\n#item-info-modal .hero-name{\n    font-size: 1.5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
